"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2017 Flowhub UG
//     (c) 2013 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license

/* eslint-disable
    class-methods-use-this,
    import/no-unresolved,
*/
var fbpGraph = require('fbp-graph');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var registerLoader = require('./loader/register');

var platform = require('./Platform'); // ## The NoFlo Component Loader
//
// The Component Loader is responsible for discovering components
// available in the running system, as well as for instantiating
// them.
//
// Internally the loader uses a registered, platform-specific
// loader. NoFlo ships with a loader for Node.js that discovers
// components from the current project's `components/` and
// `graphs/` folders, as well as those folders of any installed
// NPM dependencies. For browsers and embedded devices it is
// possible to generate a statically configured component
// loader using the [noflo-component-loader](https://github.com/noflo/noflo-component-loader) webpack plugin.


var ComponentLoader = /*#__PURE__*/function (_EventEmitter) {
  _inherits(ComponentLoader, _EventEmitter);

  var _super = _createSuper(ComponentLoader);

  function ComponentLoader(baseDir) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ComponentLoader);

    _this = _super.call(this);
    _this.baseDir = baseDir;
    _this.options = options;
    _this.components = null;
    _this.libraryIcons = {};
    _this.processing = false;
    _this.ready = false;

    _this.setMaxListeners(0);

    return _this;
  } // Get the library prefix for a given module name. This
  // is mostly used for generating valid names for namespaced
  // NPM modules, as well as for convenience renaming all
  // `noflo-` prefixed modules with just their base name.
  //
  // Examples:
  //
  // * `my-project` becomes `my-project`
  // * `@foo/my-project` becomes `my-project`
  // * `noflo-core` becomes `core`


  _createClass(ComponentLoader, [{
    key: "getModulePrefix",
    value: function getModulePrefix(name) {
      if (!name) {
        return '';
      }

      var res = name;

      if (res === 'noflo') {
        return '';
      }

      if (res[0] === '@') {
        res = res.replace(/@[a-z-]+\//, '');
      }

      return res.replace(/^noflo-/, '');
    } // Get the list of all available components

  }, {
    key: "listComponents",
    value: function listComponents(callback) {
      var _this2 = this;

      if (this.processing) {
        this.once('ready', function () {
          return callback(null, _this2.components);
        });
        return;
      }

      if (this.components) {
        callback(null, this.components);
        return;
      }

      this.ready = false;
      this.processing = true;
      this.components = {};
      registerLoader.register(this, function (err) {
        _this2.processing = false;
        _this2.ready = true;

        _this2.emit('ready', true);

        if (err) {
          callback(err);
          return;
        }

        callback(null, _this2.components);
      });
    } // Load an instance of a specific component. If the
    // registered component is a JSON or FBP graph, it will
    // be loaded as an instance of the NoFlo subgraph
    // component.

  }, {
    key: "load",
    value: function load(name, callback, metadata) {
      var _this3 = this;

      if (!this.ready) {
        this.listComponents(function (err) {
          if (err) {
            callback(err);
            return;
          }

          _this3.load(name, callback, metadata);
        });
        return;
      }

      var component = this.components[name];

      if (!component) {
        // Try an alias
        var keys = Object.keys(this.components);

        for (var i = 0; i < keys.length; i += 1) {
          var componentName = keys[i];

          if (componentName.split('/')[1] === name) {
            component = this.components[componentName];
            break;
          }
        }

        if (!component) {
          // Failure to load
          callback(new Error("Component ".concat(name, " not available with base ").concat(this.baseDir)));
          return;
        }
      }

      if (this.isGraph(component)) {
        this.loadGraph(name, component, callback, metadata);
        return;
      }

      this.createComponent(name, component, metadata, function (err, instance) {
        var inst = instance;

        if (err) {
          callback(err);
          return;
        }

        if (!inst) {
          callback(new Error("Component ".concat(name, " could not be loaded.")));
          return;
        }

        if (name === 'Graph') {
          inst.baseDir = _this3.baseDir;
        }

        if (typeof name === 'string') {
          inst.componentName = name;
        }

        if (inst.isLegacy()) {
          platform.deprecated("Component ".concat(name, " uses legacy NoFlo APIs. Please port to Process API"));
        }

        _this3.setIcon(name, inst);

        callback(null, inst);
      });
    } // Creates an instance of a component.

  }, {
    key: "createComponent",
    value: function createComponent(name, component, metadata, callback) {
      var e;
      var instance;
      var implementation = component;

      if (!implementation) {
        callback(new Error("Component ".concat(name, " not available")));
        return;
      } // If a string was specified, attempt to `require` it.


      if (typeof implementation === 'string') {
        if (typeof registerLoader.dynamicLoad === 'function') {
          registerLoader.dynamicLoad(name, implementation, metadata, callback);
          return;
        }

        callback(Error("Dynamic loading of ".concat(implementation, " for component ").concat(name, " not available on this platform.")));
        return;
      } // Attempt to create the component instance using the `getComponent` method.


      if (typeof implementation.getComponent === 'function') {
        try {
          instance = implementation.getComponent(metadata);
        } catch (error) {
          e = error;
          callback(e);
          return;
        } // Attempt to create a component using a factory function.

      } else if (typeof implementation === 'function') {
        try {
          instance = implementation(metadata);
        } catch (error1) {
          e = error1;
          callback(e);
          return;
        }
      } else {
        callback(new Error("Invalid type ".concat(_typeof(implementation), " for component ").concat(name, ".")));
        return;
      }

      callback(null, instance);
    } // Check if a given filesystem path is actually a graph

  }, {
    key: "isGraph",
    value: function isGraph(cPath) {
      // Live graph instance
      if (_typeof(cPath) === 'object' && (cPath instanceof fbpGraph.Graph || Array.isArray(cPath.nodes) && Array.isArray(cPath.edges) && Array.isArray(cPath.initializers))) {
        return true;
      } // Graph JSON definition


      if (_typeof(cPath) === 'object' && cPath.processes && cPath.connections) {
        return true;
      }

      if (typeof cPath !== 'string') {
        return false;
      } // Graph file path


      return cPath.indexOf('.fbp') !== -1 || cPath.indexOf('.json') !== -1;
    } // Load a graph as a NoFlo subgraph component instance

  }, {
    key: "loadGraph",
    value: function loadGraph(name, component, callback, metadata) {
      var _this4 = this;

      this.createComponent(name, this.components.Graph, metadata, function (error, graph) {
        var g = graph;

        if (error) {
          callback(error);
          return;
        }

        g.loader = _this4;
        g.baseDir = _this4.baseDir;
        g.inPorts.remove('graph');
        g.setGraph(component, function (err) {
          if (err) {
            callback(err);
            return;
          }

          _this4.setIcon(name, g);

          callback(null, g);
        });
      });
    } // Set icon for the component instance. If the instance
    // has an icon set, then this is a no-op. Otherwise we
    // determine an icon based on the module it is coming
    // from, or use a fallback icon separately for subgraphs
    // and elementary components.

  }, {
    key: "setIcon",
    value: function setIcon(name, instance) {
      // See if component has an icon
      if (!instance.getIcon || instance.getIcon()) {
        return;
      } // See if library has an icon


      var _name$split = name.split('/'),
          _name$split2 = _slicedToArray(_name$split, 2),
          library = _name$split2[0],
          componentName = _name$split2[1];

      if (componentName && this.getLibraryIcon(library)) {
        instance.setIcon(this.getLibraryIcon(library));
        return;
      } // See if instance is a subgraph


      if (instance.isSubgraph()) {
        instance.setIcon('sitemap');
        return;
      }

      instance.setIcon('gear');
    }
  }, {
    key: "getLibraryIcon",
    value: function getLibraryIcon(prefix) {
      if (this.libraryIcons[prefix]) {
        return this.libraryIcons[prefix];
      }

      return null;
    }
  }, {
    key: "setLibraryIcon",
    value: function setLibraryIcon(prefix, icon) {
      this.libraryIcons[prefix] = icon;
    }
  }, {
    key: "normalizeName",
    value: function normalizeName(packageId, name) {
      var prefix = this.getModulePrefix(packageId);
      var fullName = "".concat(prefix, "/").concat(name);

      if (!packageId) {
        fullName = name;
      }

      return fullName;
    } // ### Registering components at runtime
    //
    // In addition to components discovered by the loader,
    // it is possible to register components at runtime.
    //
    // With the `registerComponent` method you can register
    // a NoFlo Component constructor or factory method
    // as a component available for loading.

  }, {
    key: "registerComponent",
    value: function registerComponent(packageId, name, cPath, callback) {
      var fullName = this.normalizeName(packageId, name);
      this.components[fullName] = cPath;

      if (callback) {
        callback();
      }
    } // With the `registerGraph` method you can register new
    // graphs as loadable components.

  }, {
    key: "registerGraph",
    value: function registerGraph(packageId, name, gPath, callback) {
      this.registerComponent(packageId, name, gPath, callback);
    } // With `registerLoader` you can register custom component
    // loaders. They will be called immediately and can register
    // any components or graphs they wish.

  }, {
    key: "registerLoader",
    value: function registerLoader(loader, callback) {
      loader(this, callback);
    } // With `setSource` you can register a component by providing
    // a source code string. Supported languages and techniques
    // depend on the runtime environment, for example CoffeeScript
    // components can only be registered via `setSource` if
    // the environment has a CoffeeScript compiler loaded.

  }, {
    key: "setSource",
    value: function setSource(packageId, name, source, language, callback) {
      var _this5 = this;

      if (!registerLoader.setSource) {
        callback(new Error('setSource not allowed'));
        return;
      }

      if (!this.ready) {
        this.listComponents(function (err) {
          if (err) {
            callback(err);
            return;
          }

          _this5.setSource(packageId, name, source, language, callback);
        });
        return;
      }

      registerLoader.setSource(this, packageId, name, source, language, callback);
    } // `getSource` allows fetching the source code of a registered
    // component as a string.

  }, {
    key: "getSource",
    value: function getSource(name, callback) {
      var _this6 = this;

      if (!registerLoader.getSource) {
        callback(new Error('getSource not allowed'));
        return;
      }

      if (!this.ready) {
        this.listComponents(function (err) {
          if (err) {
            callback(err);
            return;
          }

          _this6.getSource(name, callback);
        });
        return;
      }

      registerLoader.getSource(this, name, callback);
    } // `getLanguages` gets a list of component programming languages supported by the `setSource`
    // method on this runtime instance.

  }, {
    key: "getLanguages",
    value: function getLanguages() {
      if (!registerLoader.getLanguages) {
        // This component loader doesn't support the method, default to normal JS
        return ['javascript', 'es2015'];
      }

      return registerLoader.getLanguages();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.components = null;
      this.ready = false;
      this.processing = false;
    }
  }]);

  return ComponentLoader;
}(EventEmitter);

exports.ComponentLoader = ComponentLoader;